import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { StockLocationActions, StockLocationStore, STATUS } from 'Stores/stockLocationStore'
import StockLocationForm from 'Modules/stockLocation/stockLocationForm'

export default class StockLocationCreate extends Component {
  constructor(props) {
    super(props)
    this.stores = [StockLocationStore]
    this.storeKeys = ['status']
  }
  componentDidMount() {
    StockLocationActions.createEmptyStockLocation()
  }
  componentDidUpdate() {
    if (this.state.status === STATUS.UPDATE_SUCCESS) {
      toast.success('StockLocation Created', {
        autoClose: 3000,
        onClose: () => {
          StockLocationActions.clearFormToast()
        }
      })
      StockLocationActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.UPDATE_ERROR) {
      toast.error('StockLocation Create Failed', {
        autoClose: 3000,
        onClose: () => {
          StockLocationActions.clearFormToast()
        }
      })
      StockLocationActions.clearFormToast(STATUS.REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <StockLocationForm />
      </React.Fragment>
    )
  }
}
